import React from 'react';
import { Helmet } from 'react-helmet'; // ✅ Import Helmet
import { Smartphone, Code, TrendingUp, Briefcase } from "lucide-react";

const Mobileappdev = () => {
  return (
    <section className="tech-services-section">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Enterprise Mobile App Development | Pravisht Digital</title>
        <meta
          name="description"
          content="Pravisht designs and develops scalable, high-performing mobile applications across native and cross-platform environments for enterprises and consumers."
        />
        <meta
          name="keywords"
          content="Mobile App Development, Android, iOS, Flutter, Kotlin, Xamarin, Mobile Testing, Mobile Websites, Pravisht Digital"
        />
        <meta property="og:title" content="Enterprise Mobile App Development | Pravisht Digital" />
        <meta
          property="og:description"
          content="Delivering robust, scalable mobile apps with cutting-edge technologies like Flutter, Kotlin, Xamarin, and cloud testing."
        />
        <meta property="og:type" content="website" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet>
      <div className="breadcrumb">
        <a href="/">Home</a> &gt; <span>Enterprise Mobile App Development</span>
      </div>

      <div className="about-heading-section">
        <h1>Enterprise Mobile App Development</h1>
        <p>
          At Pravisht, we design and develop scalable and high-performing mobile applications for both business and consumer needs—across native and cross-platform environments. Our mobile app expertise extends across industries, platforms, and modern development frameworks.
        </p>
      </div>

      <div className="about-image-fullscreen">
        <img src="/testing_pravisht.jpg" alt="Pravisht Mobile App Development" />
      </div>

      <div className="core-offerings">
        <div className="how-we-help__content">
          <p className="how-we-help__description services-desc">Our Services</p>
          <h1 className="how-we-help__title">Our Capabilities</h1>
          <hr className="portfolio-horizontalline" />
        </div>

        <div className="offerings-grid">
          <div className="offering-card app-dev-card">
            <h4>📱 Android App Development</h4>
            <p>
              We build robust and scalable Android applications using native tools and modern design patterns tailored to your enterprise or consumer needs.
            </p>
          </div>

          <div className="offering-card consulting-card">
            <h4>📱 iOS App Development</h4>
            <p>
              Our team delivers engaging and reliable iOS apps for iPhone and iPad users, aligned with Apple’s ecosystem and UX guidelines.
            </p>
          </div>

          <div className="offering-card iot-blockchain-card">
            <h4>📱 Flutter / Kotlin App Development</h4>
            <p>
              We use Flutter and Kotlin for modern cross-platform app development. Our engineers design reusable components and access platform-specific APIs to build apps that work seamlessly across Android, iOS, and Windows.
            </p>
          </div>

          <div className="offering-card automation-card">
            <h4>❎ Xamarin App Development</h4>
            <p>
              With Xamarin, we help businesses develop once and deploy across multiple platforms. Our US-based designers and developers ensure consistency, performance, and cost efficiency for cross-platform applications.
            </p>
          </div>

          <div className="offering-card mobile-apps-card">
            <h4>📲 Mobile App Testing</h4>
            <p>
              Our cloud-based mobile app testing framework simulates real-world performance to ensure your application is bug-free, responsive, and production-ready.
            </p>
          </div>

          <div className="offering-card consulting-card">
            <h4>🌐 Mobile Website Development</h4>
            <p>
              We develop mobile-first websites using technologies like Sencha, jQuery Mobile, HTML5, JavaScript, and PhoneGap, providing rich experiences across devices and browsers.
            </p>
          </div>
        </div>
      </div>

      <div className="engagement-layers-and-why-choose" style={{ backgroundColor: '#f1f4f3', marginBottom: '60px' }}>
       
          <h3 className="section-subtitle">Mobile App Delivery Excellence</h3>
          <p>We deliver consistent outcomes across the mobile app lifecycle:</p>
        

        <div className="bottom-sections-grid">
          <div className="how-we-help__cards">
            {[
              { icon: <Smartphone size={40} />, title: "User-Centered Design", desc: "Focus on seamless UI/UX across platforms" },
              { icon: <Code size={40} />, title: "Cross-Platform Codebase", desc: "Code once, deploy everywhere efficiently" },
              { icon: <TrendingUp size={40} />, title: "Performance-Optimized Apps", desc: "Deliver responsive, bug-free apps" },
              { icon: <Briefcase size={40} />, title: "Scalable Architecture", desc: "Support millions of users with scalable design" }
            ].map((card, i) => (
              <div className="how-we-help__card" key={i} style={{ height: '190px', cursor: 'default' }}>
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mobileappdev;
